package com.hyperether.goodjob.database

import kotlin.Long
import kotlin.String

public data class Job(
  public val id: Long,
  public val _id: String?,
  public val jobTitle: String?,
  public val status: String?,
  public val assignees: String?,
  public val creatorId: String?,
  public val workspaceId: String?,
  public val start_at: String?,
  public val end_at: String?,
  public val repeat: String?,
  public val repeatInterval: String?,
  public val startDate: String?,
  public val dueDate: String?,
  public val jobDuration: Long?,
  public val steps: String?,
  public val userId: String?,
  public val contactId: String?,
  public val contactSiteName: String?,
  public val contactParentId: String?,
  public val notes: String?,
  public val fileObjects: String?,
  public val completionReport: String?,
)
